import { render, staticRenderFns } from "./xmlx.vue?vue&type=template&id=febbdc24&scoped=true"
import script from "./xmlx.vue?vue&type=script&lang=js"
export * from "./xmlx.vue?vue&type=script&lang=js"
import style0 from "./xmlx.vue?vue&type=style&index=0&id=febbdc24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febbdc24",
  null
  
)

export default component.exports